export const SLACK_ACTIVATION_STATUS_QUERY = 'slackActivationStatus';
export const SLACK_OAUTH_MAPPING_QUERY = 'slackOauthMapping';
export const SLACK_ACTIVATION_VALIDATION_QUERY = 'slackActivationValidation';
